<template>
	<div>
		<ButtonClassic
			labelText="Title Application"
			@click="onTitleApplicationClick"
			v-if="showButtons"
		/>
		<ButtonClassic
			labelText="Deal Events"
			@click="onDealEventsClick"
			v-if="showButtons"
		/>
		<ButtonClassic
			labelText="Credit Application"
			@click="onCreditApplicationClick"
			v-if="showButtons"
		/>

		<ButtonClassic
			labelText="Credit Report Import"
			@click="onCreditReportImportClick"
			v-if="showButtons"
		/>

		<ButtonClassic
			labelText="Credit Application import"
			@click="onCreditApplicationImportClick"
			v-if="showButtons"
		/>

		<ButtonClassic
			labelText="Credit Application History"
			@click="onCreditApplicationHistoryClick"
			v-if="showButtons"
		/>

		<ButtonClassic
			labelText="Credit Report"
			@click="onCreditReportClick"
			v-if="showButtons"
		/>

		<ButtonClassic
			labelText="Credit Request"
			@click="onCreditRequestClick"
			v-if="showButtons"
		/>

		<ButtonClassic
			labelText="Credit Report Bureaus"
			@click="onCreditReportBureausClick"
			v-if="showButtons"
		/>

		<TitleApplication
			:dealId="id"
			:visible="titleApplicationVisible"
			v-if="currentTitleIntegrationId"
			:integrationId="currentTitleIntegrationId"
			:dealType="dealType"
			:stateCode="stateCode"
			:deal="modalData"
			@cancel="onTitleApplicationCancel"
			@ready="onTitleApplicationReady"
			@submit="onTitleApplicationSubmit"
			@complete="onTitleApplicationComplete"
		/>

		<CreditRequest
			:id="id"
			:visible="creditRequestVisible"
			:deal="modalData"
			:isProspect="false"
			@cancel="onCreditRequestCancel"
			ref="CreditRequestModal"
		/>

		<DealEventsModal
			:dealId="id"
			:visible="dealEventsVisible"
			@close="onDealEventsClose"
			@ready="onDealEventsReady"
		/>
	</div>
</template>

<script>
import TitleApplication from './title/title-application-modal.vue';
import CreditRequest from './credit/credit-request-modal.vue';
import pageMixin from '@/mixins/page-mixin';
import ButtonClassic from '@/components/forms/button/button-classic.vue';
import DealEventsModal from './deal-events-modal.vue';
import messageHandlerMixin from '@/mixins/message-handler-mixin';

export default {
	name: 'Deal',
	metaInfo() {
		return { title: 'Deal ' + this.dealNumber };
	},
	mixins: [pageMixin, messageHandlerMixin],
	components: {
		TitleApplication,
		ButtonClassic,
		DealEventsModal,
		CreditRequest
	},
	data() {
		return {
			dealEventsVisible: false,
			titleApplicationVisible: false,
			//creditApplicationVisible: false,
			creditRequestVisible: false,
			//creditReportImportVisible: false,
			//creditReportVisible: false,
			//creditApplicationImportVisible: false,
			creditApplicationHistoryVisible: false,
			loadDealEvents: false,
			dealType: undefined,
			stateCode: 'FL',
			modalData: undefined,
			currentTitleIntegrationId: undefined,
			titleApplicationReady: false,
			//creditApplicationReady: false,
			//creditReportReady: false,
			//creditApplicationImportReady: false,
			creditApplicationHistoryReady: false
		};
	},
	props: {
		id: {
			type: Number,
			required: true
		},
		titleIntegrationId: {
			type: Number
		},
		dealNumber: {
			type: String,
			default: ''
		},
		/**
		 * tells page which modal to open
		 * ta = title application
		 * de = deal events
		 * ca = credit application
		 */
		modal: {
			type: String
		},
		/***
		 * tells page this is being iframed
		 */
		frame: {
			type: Boolean
		}
	},
	created() {
		this.currentTitleIntegrationId = this.titleIntegrationId;

		if (!this.frame) {
			this.hidePageLoader();
		} else {
			this.sendPageReadyMessage();
		}

		//this.showModal(this.modal);
	},
	computed: {
		showButtons() {
			return !this.modal && !this.frame;
		}
	},
	methods: {
		onModalMessage(message) {
			this.modalData = message.options;
			this.showModal(message.modal);
		},
		showModal(modal) {
			switch (modal) {
				case 'ta':
					this.onTitleApplicationClick();
					break;
				case 'de':
					this.onDealEventsClick();
					break;
				case 'cai':
					this.onCreditApplicationImportClick();
					break;
				case 'ca':
					this.onCreditApplicationClick();
					break;
				case 'cr':
					this.onCreditReportImportClick();
					break;
				default:
					break;
			}
		},
		sendPageReadyMessage() {
			this.postIFrameReadyMessageToAccess();
			// this.postMessageToAccess({
			// 	target: this.accessMessageAction,
			// 	action: 'iframeReadyForModal'
			// });
		},
		onTitleApplicationCancel() {
			this.sendCloseMessageToAccess();
			this.titleApplicationVisible = false;
		},
		onCreditRequestCancel() {
			this.sendCloseMessageToAccess();
			this.creditRequestVisible = false;
		},
		onCreditApplicationHistoryCancel() {
			this.sendCloseMessageToAccess();
			this.creditApplicationHistoryVisible = false;
		},
		onTitleApplicationClick() {
			this.showPageLoader();
			this.currentTitleIntegrationId = 123; //just here for local testing

			if (this.titleApplicationReady) {
				this.titleApplicationVisible = true;

				this.hidePageLoader();
			}
		},
		async onCreditApplicationClick() {
			let query = {
				companyId: this.companyId,
				loadExistingApp: false
			};

			this.$router.push({
				name: 'CreditApplication',
				query: query
			});
		},
		async onCreditRequestClick() {
			this.showPageLoader();
			this.creditRequestVisible = true;
			this.hidePageLoader();
		},
		async onCreditReportBureausClick() {
			let query = {
				id: this.id,
				deal: this.deal
			};

			this.$router.push({
				name: 'CreditReportBureaus',
				query: query
			});
		},
		async onCreditReportImportClick() {
			let query = {
				id: this.id,
				deal: this.deal,
				isProspect: this.isProspect
			};

			this.$router.push({
				name: 'CreditReportImport',
				query: query
			});
		},
		onCreditApplicationHistoryClick() {
			this.showPageLoader();
			this.onCreditApplicationHistoryReady();
			this.currentTitleIntegrationId = 123;

			if (this.creditApplicationHistoryReady) {
				this.creditApplicationHistoryVisible = true;
				this.hidePageLoader();
			}
		},
		onCreditApplicationImportClick() {
			let query = {
				id: this.id,
				dealType: this.dealType,
				isProspect: this.isProspect
			};

			this.$router.push({
				name: 'CreditApplicationImport',
				query: query
			});
		},
		async onCreditReportClick() {
			this.showPageLoader();
			let query = {
				id: this.id,
				deal: this.deal,
				isProspect: this.isProspect
			};

			this.$router.push({
				name: 'CreditReport',
				query: query
			});
			this.hidePageLoader();
		},
		onTitleApplicationComplete() {
			this.sendCloseMessageToAccess();
			this.titleApplicationVisible = false;
			this.hidePageLoader();
		},
		onCreditApplicationHistoryComplete() {
			this.sendCloseMessageToAccess();
			this.creditApplicationHistoryVisible = false;
			this.hidePageLoader();
		},
		onTitleApplicationSubmit() {
			this.titleApplicationVisible = false;
			this.showPageLoader();
		},
		onCreditApplicationHistorySubmit() {
			this.creditApplicationHistoryVisible = false;
			this.showPageLoader();
		},
		onDealEventsClick() {
			this.showPageLoader();
			this.dealEventsVisible = true;
		},
		onDealEventsClose() {
			this.sendCloseMessageToAccess();
			this.dealEventsVisible = false;
		},
		onTitleApplicationReady() {
			this.titleApplicationReady = true;
			this.titleApplicationVisible = true;
			this.hidePageLoader();
		},
		onCreditReportReady() {
			this.creditReportReady = true;
			this.creditReportVisible = true;
			this.hidePageLoader();
		},
		onCreditApplicationHistoryReady() {
			this.creditApplicationHistoryReady = true;
			this.creditApplicationHistoryVisible = true;
			this.hidePageLoader();
		},
		onDealEventsReady() {
			this.hidePageLoader();
		},
		sendCloseMessageToAccess() {
			// this.postMessageToAccess({
			// 	target: this.accessMessageAction,
			// 	action: 'close'
			// });
			this.postCloseMessageToAccess();
		}
	}
};
</script>

<style lang="scss" scoped></style>
